export default "__VITE_PUBLIC_ASSET__cc4d8e81__"